// @noflow
/* eslint-disable no-console */
/* globals global, console, window */
import { PlayerEvent } from '../../player/utils';

const eventNames = [
  'onReady',
  [PlayerEvent.Play],
  [PlayerEvent.Playing],
  [PlayerEvent.Paused],
  [PlayerEvent.PlaybackFinished],
  'onTimeChanged',
  [PlayerEvent.StallStarted],
  [PlayerEvent.StallEnded],
  'onSeek',
  'onSeeked',
  [PlayerEvent.SourceLoaded],
  [PlayerEvent.SourceUnloaded],
  [PlayerEvent.Destroy],
  'onMetadata',
  [PlayerEvent.Error],
  [PlayerEvent.Seek],
  [PlayerEvent.VideoPlaybackQualityChanged],
];

class PlayerManagers {
  constructor(managers) {
    this._managers = managers;
    if (!global.onPlayerUnload && typeof window !== 'undefined' && window.addEventListener) {
      global.onPlayerUnload = window.addEventListener('unload', () => {
        return this.callEvent('onUnload');
      });
    }
  }

  get events() {
    // supply player with an events object that will call the events for each manager
    const events = {};
    eventNames.forEach(eventName => {
      events[eventName] = (...args) => this.callEvent(eventName, args);
    });
    return events;
  }

  callEvent(eventName, args = []) {
    this._managers.forEach(manager => {
      if (manager.enabled && typeof manager.events[eventName] === 'function') {
        if (eventName !== 'onTimeChanged') console.warn(manager.constructor.name, eventName);
        if (!manager.events[eventName]) console.warn("Event doesn't exist", eventName);
        manager.events[eventName](...args);
      }
    });
  }

  destroy() {
    /* Dispatching "Destroy" event to force managers to cleanup properly. */
    this.callEvent(PlayerEvent.Destroy);
    this._managers = [];
  }
}

export default PlayerManagers;
